// Routes owned by the Tools module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const toolsPaths = {
    // Tools
    toolsConvertWebp: '/tools/convert-webp',
    toolsWafFreeReport: '/tools/waf-free-report',
} as const
